export default __webpack_public_path__ + "static/media/whatwedo2.8b7aca43.jpg";